// src/components/header/Header.js
import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import logo from './PSI_logo.png';      
import styles from './header.module.css';

export default function Header() {
  return (
    <header className={styles.header}>
      {/* Left side: Logo*/}
      <Link to="/" className={styles.logoContainer}>
        <div className={styles.logoWrapper}>
          <img
            src={logo}              
            alt="PSI Logo"
            width={96}
            height={38}
            className={styles.logoImage}
          />
          <span className={styles.logoText}>Pairwise Comparison Tool</span>
        </div>
      </Link>

      {/* Right side: Link */}
      <nav className={styles.navContainer}>
        <NavLink
          to="/"
          className={({ isActive }) => `${styles.navLink} ${isActive ? styles.navLinkActive : ''}`}
        >
          Home
        </NavLink>
        <NavLink
          to="/tool"
          state={{ reset: true }}
          className={({ isActive }) => `${styles.navLink} ${isActive ? styles.navLinkActive : ''}`}
        >
          Tool
        </NavLink>
      </nav>
    </header>
  );
}
